export function formatLongDate(item, isNumber = false) {
    if (!item) return '';

    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const isEnglish = currentLanguage === 'en';

    let s = String(item).trim();
    const isPureDate = /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(s);
    const rawHasMidnight = /(?:T|\s)00:00(:00)?(\.0+)?/i.test(s);
    if (isPureDate) {
        s = s + 'T00:00:00+04:00';
    } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(\.\d+)?$/.test(s)) {
        s = s + '+04:00';
    }
    const incomingDate = new Date(s);

    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Dubai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    }).formatToParts(incomingDate);

    const get = t => parts.find(p => p.type === t)?.value;
    const h24 = get('hour');
    const min = get('minute');
    const isMidnight =
        isPureDate ||
        rawHasMidnight ||
        ((h24 === '00' || h24 === '0' || h24 === '24') && (min === '00' || min === '0')) ||
        (incomingDate.getHours() === 0 && incomingDate.getMinutes() === 0);

    if (isNumber) {
        const dd = get('day');
        const mm = get('month');
        const yyyy = get('year');
        let timeStr = '';
        if (!isMidnight) {
            let h12 = parseInt(h24, 10) % 12 || 12;
            const hStr = String(h12).padStart(2, '0');
            const isPm = parseInt(h24, 10) >= 12;
            const ampm = isPm ? (isEnglish ? 'PM' : 'م') : (isEnglish ? 'AM' : 'ص');
            timeStr = ` ${hStr}:${min} ${ampm}`;
        }
        return `${dd}/${mm}/${yyyy}${timeStr}`;
    }

    const dateOptions = {
        timeZone: 'Asia/Dubai',
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        ...(!isMidnight && {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        }),
    };

    return incomingDate.toLocaleString(isEnglish ? 'en-US' : 'ar-EG-u-nu-latn', dateOptions);
}
